import { Navigate } from "react-router-dom";
import { ROLES } from "../config/Roles.config"; 

// Zingworks routes
import AccountMaster from "../Pages/Zingworks/AccountMaster/AccountMaster";
import AssignSuperAdminMaster from "../Pages/Zingworks/AssignSuperAdminMaster/AssignSuperAdminMaster";

// Protected Routes of all Masters
import CompanyDashboard from "../Pages/Dashboard/CompanyDashboard";
import UserMaster from "../Pages/UserMaster/UserMaster";
import BranchMaster from "../Pages/BranchMaster/BranchMaster";
import DepartmentMaster from "../Pages/DepartmentMaster/DepartmentMaster";
import AreaMaster from "../Pages/AreaMaster/AreaMaster";
// import ActivityMaster from "../Pages/ActivityMaster/ActivityMaster";
import AuditTypeMaster from "../Pages/AuditTypeMaster/AuditTypeMaster";
import AuditTypeCategoryMaster from "../Pages/AuditTypeCategoryMaster/AuditTypeCategoryMaster";
import CreateOrUpdateAuditTypeMaster from "../Pages/AuditTypeMaster/components/CreateOrUpdateAuditTypeMaster";
import AuditMaster from "../Pages/AuditMaster/AuditMaster";

// Public Routes
import Login from "../Pages/Authentication/Login";
import ForgotPassword from "../Pages/Authentication/ForgotPassword";
import UserProfile from "../Pages/UserProfile/UserProfile";
import CreateNewAudit from "../Pages/AuditMaster/components/CreateNewOrUpdateAudit";
import AuditReports from "../Pages/Reports/AuditReports";

// Importing Third Party Audit Master
import ThirdPartyAuditMaster from "../Pages/ThirdPartyAuditMaster/ThirdPartyAuditMaster";
import CreateNewOrUpdateThirdPartyAudit from "../Pages/ThirdPartyAuditMaster/components/CreateNewOrUpdateThirdPartyAudit";


// Common routes for all the user except 'Zingworks-Admin'
export const CommonRoutes = [
  {
    path: "/*",
    element: <Navigate to="/" replace />,
    roles: [
      ROLES.ZINGWORKS,
      ROLES.SUPERADMIN,
      ROLES.ADMIN,
      ROLES.AUDITOR,
      ROLES.AUDITEE,
      ROLES.INCHARGE,
    ],
  },
];

// Secure routes according to dynamic user role
export const SecureRoutes = [
  {
    path: "/",
    element: <CompanyDashboard />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.USER],
  },
  {
    path: "/",
    element: <AccountMaster />,
    roles: [ROLES.ZINGWORKS],
  },
  {
    path: "/assign-super-admin",
    element: <AssignSuperAdminMaster />,
    roles: [ROLES.ZINGWORKS],
  },
  {
    path: "/profile",
    element: <UserProfile />,
    roles: [ROLES.ZINGWORKS, ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.USER],
  },
  {
    path: "/user-master",
    element: <UserMaster />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: "/branch-master",
    element: <BranchMaster />,
    roles: [ROLES.SUPERADMIN],
  },
  {
    path: "/department-master",
    element: <DepartmentMaster />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: "/area-master",
    element: <AreaMaster />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  // {
  //   path: "/activity-master",
  //   element: <ActivityMaster />,
  //   roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
  // },

  // 
  {
    path: "/audit-type-master",
    element: <AuditTypeMaster />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: "/audit-type-category-master",
    element: <AuditTypeCategoryMaster />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: "/audit-type-master/create",
    element: <CreateOrUpdateAuditTypeMaster />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: "/audit-type-master/view/:auditTypeId",
    element: <CreateOrUpdateAuditTypeMaster />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: "/audit-type-master/update/:auditTypeId",
    element: <CreateOrUpdateAuditTypeMaster />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  
  // Audit master sub-components for audit create/update/view
  {
    path: "/audit-master",
    element: <AuditMaster />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.USER],
  },
  {
    path: "/audit-master/create",
    element: <CreateNewAudit />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
  },
  {
    path: "/audit-master/view/:auditId",
    element: <CreateNewAudit />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.USER],
  },
  {
    path: "/audit-master/update/:auditId",
    element: <CreateNewAudit />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.USER],
  },

  // Third Party Audit master sub-components for create/update/view
  {
    path: "/third-party-audit-master",
    element: <ThirdPartyAuditMaster />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.USER],
  },
  {
    path: "/third-party-audit-master/create",
    element: <CreateNewOrUpdateThirdPartyAudit />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.USER],
  },
  {
    path: "/third-party-audit-master/view/:auditId",
    element: <CreateNewOrUpdateThirdPartyAudit />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.USER],
  },
  {
    path: "/third-party-audit-master/update/:auditId",
    element: <CreateNewOrUpdateThirdPartyAudit />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.USER],
  },

  // Reports Routes
  {
    path: "/reports",
    element: <AuditReports />,
    roles: [ROLES.SUPERADMIN, ROLES.ADMIN, ROLES.USER],
  },
];

// Public routes
export const PublicRoutes = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  ...CommonRoutes,
];
